import { SANTA_MEMBERS_APP_ID } from '../constants/applications';
import { getApplicationConfig } from './communities-context-selectors';

export const isMemberAreaActive = state => {
  return getApplicationConfig(state, SANTA_MEMBERS_APP_ID).isInstalled;
};



// WEBPACK FOOTER //
// ./app/selectors/member-area-selectors.js